import { TransactionStatus } from "@busdk/storefront-service/dist/models/enums";
import { isHeycarDealer } from './JourneyType';
import { Route } from "./Navigation";

export function redirectAccordingToStatus(status: TransactionStatus, originSystem: string): string {    
    switch (status) {
        case TransactionStatus.INITIALIZED:
            return Route.BoniLanding;
        case TransactionStatus.SOFTCREDIT_REFUSED:
            return Route.BoniRefused;
        case TransactionStatus.SOFTCREDIT_APPROVED:
            return isHeycarDealer(originSystem)
                ? Route.BoniSuccessDealer
                : Route.BoniSuccessUCC
        case TransactionStatus.APPLICATIONFORM_STARTED:
            return Route.FullApplicationForm;
        case TransactionStatus.APPLICATIONFORM_COMPLETED:
            return Route.Summary;
        case TransactionStatus.CREDIT_APPROVED:
        case TransactionStatus.CREDIT_REFUSED:
        case TransactionStatus.DOCUMENTS_UPLOADED:
        case TransactionStatus.BOP_COMPLETED: // Status BOP_COMPLETED should only occur in case idnow initialization fails
            return Route.DocumentUploadSuccess;
        case TransactionStatus.ESIGN_READY:
            return Route.Esign;
        case TransactionStatus.ESIGN_REFUSED:
            return Route.EsignFailed;
        case TransactionStatus.ESIGN_COMPLETED:
        case TransactionStatus.CONTRACT_SIGNED:
            return Route.EsignSuccess;
        default:
            console.log(`redirectAccordingToStatus could not handle status ${status}`);
            return Route.Error;
    }
}
